import request from '@/utils/request'


export function loadAEFC_summary(params) {
  return request({ url: 'vaefc', method: 'post', data: params })
} 

